import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { httpinstance } from "../../axios/api"
// Async thunk for fetching organization list

export const vehicletype=createAsyncThunk('vehicletype',async(value)=>{
  try{
    const url=`/vehicle-types/listVehicleType`;
    const response =await httpinstance.post(url,value);
    return response.data;
  }catch(err){
    return err.response.data
  }
})
export const caldistance=createAsyncThunk('caldistance',async(value)=>{
  try{
    const url=`/vehicle-types/calculate_distance`;
    const response =await httpinstance.post(url,value);
    return response.data;
  }catch(err){
    return err.response.data
  }
})

// Initial state
const initialState = {
  vehicletype: [],
  caldistance:[],

};

// Organization slice
const Vehicletypeslice = createSlice({
  name: 'vehicletype',
  initialState,
  reducers: {
    
  },
 
  extraReducers: (builder) => {
    builder
      
      .addCase(vehicletype.fulfilled, (state, { payload }) => {
        state.createorg = payload;
      }).addCase(vehicletype.rejected, (state, action) => {
        console.error('error in vehicletype section', action.error);
      }).addCase(caldistance.fulfilled, (state, { payload }) => {
        state.caldistance = payload;
      }).addCase(caldistance.rejected, (state, action) => {
        console.error('error in distance cal section', action.error);
      })
  },
})


// Export actions and reducer
// export const { setOrganizationCreated } = organizationSlice.actions;
export default Vehicletypeslice.reducer;
